export const Simulator = {
  DIV_NAME_SIMULATOR: 'simulator-blip-chat',
};
